var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"variant":"transparent","no-wrap":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }